import GradeLevel from 'models/GradeLevel';
import Lesson from 'models/Lesson';
import Subject from 'models/Subject';

const MockLessons: Lesson[] = [
  ...Array(9).fill({
    allResourcesLicensed: true,
    categories: ['Robotics', 'Syntax-based programming'],
    contentStrands: {
      math: ['Algebra', 'Data Analysis and Probability'],
      socialStudies: ['History'],
    },
    cstaStandards: ['3A-CS-01', '3A-NI-05', '3A-NI-06', '3A-NI-08'],
    displayPublicly: true,
    educatorName: 'Avery Smith',
    emailAddress: 'avery.smith@school.edu',
    gradeLevels: [GradeLevel.High],
    lessonDescription:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum feugiat eros ullamcorper sem iaculis, vel sollicitudin lacus auctor. In aliquam justo libero, vel pellentesque risus aliquet volutpat. Nunc et pulvinar turpis, sed eleifend eros. Vivamus condimentum pulvinar tincidunt. Proin at eleifend mauris. Curabitur cursus, diam ut ultrices tincidunt, libero arcu pretium est, cursus suscipit ligula augue in nulla. Phasellus quis justo eu leo congue malesuada. Duis eget velit tellus. Aliquam et erat egestas massa sagittis accumsan.',
    lessonFileId: '1rKesjDfhGX0miYeJ6iwU9wpGpKDZ2IZP',
    lessonTitle: 'Cyber Security and Encryption',
    mnStandards: { art: ['1.1.1.1', '2.2.2.2', '3.3.3.3', '4.4.4.4', '5.5.5.5'] },
    permissionGranted: true,
    platforms: ['Scratch'],
    schoolDistrict: '1',
    schoolName: 'Sunnyvale Elementary',
    schoolState: 'MN',
    schoolZipCode: 12345,
    subjectAreas: [Subject.COMPUTER_SCIENCE, Subject.SCIENCE],
    submissionApproved: true,
    technologies: ['Arduino', 'Other'],
    timestamp: '12345',
    twitterId: 'abc',
  }),
  // This one has some invalid CSTA standards
  {
    allResourcesLicensed: true,
    categories: ['Robotics', 'Syntax-based programming'],
    contentStrands: {
      math: ['Algebra', 'Data Analysis and Probability'],
      socialStudies: ['History'],
    },
    cstaStandards: [
      '3A-CS-01',
      '3A-NI-05',
      '3A-NI-06',
      '3A-NI-08',
      '4A-CS-01',
      '2-DA-03',
      '1A-AA-03',
    ],
    displayPublicly: true,
    educatorName: 'Avery Smith',
    emailAddress: 'avery.smith@school.edu',
    gradeLevels: [GradeLevel.High],
    lessonDescription:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum feugiat eros ullamcorper sem iaculis, vel sollicitudin lacus auctor. In aliquam justo libero, vel pellentesque risus aliquet volutpat. Nunc et pulvinar turpis, sed eleifend eros. Vivamus condimentum pulvinar tincidunt. Proin at eleifend mauris. Curabitur cursus, diam ut ultrices tincidunt, libero arcu pretium est, cursus suscipit ligula augue in nulla. Phasellus quis justo eu leo congue malesuada. Duis eget velit tellus. Aliquam et erat egestas massa sagittis accumsan.',
    lessonFileId: '1rKesjDfhGX0miYeJ6iwU9wpGpKDZ2IZP',
    lessonTitle: 'Cyber Security and Encryption',
    mnStandards: { art: ['1.1.1.1', '2.2.2.2', '3.3.3.3', '4.4.4.4', '5.5.5.5'] },
    permissionGranted: true,
    platforms: ['Scratch'],
    schoolDistrict: '1',
    schoolName: 'Sunnyvale Elementary',
    schoolState: 'MN',
    schoolZipCode: 12345,
    subjectAreas: [Subject.COMPUTER_SCIENCE, Subject.SCIENCE],
    submissionApproved: true,
    technologies: ['Arduino', 'Other'],
    timestamp: '12345',
    twitterId: 'abc',
  },
  // Unapproved lesson
  {
    allResourcesLicensed: true,
    categories: ['Robotics', 'Syntax-based programming'],
    contentStrands: {
      math: ['Algebra', 'Data Analysis and Probability'],
      socialStudies: ['History'],
    },
    cstaStandards: ['3A-CS-01', '3A-NI-05', '3A-NI-06', '3A-NI-08'],
    displayPublicly: true,
    educatorName: 'Avery Smith',
    emailAddress: 'avery.smith@school.edu',
    gradeLevels: [GradeLevel.High],
    hardwareSoftware: ['Windows'],
    lessonDescription:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum feugiat eros ullamcorper sem iaculis, vel sollicitudin lacus auctor. In aliquam justo libero, vel pellentesque risus aliquet volutpat. Nunc et pulvinar turpis, sed eleifend eros. Vivamus condimentum pulvinar tincidunt. Proin at eleifend mauris. Curabitur cursus, diam ut ultrices tincidunt, libero arcu pretium est, cursus suscipit ligula augue in nulla. Phasellus quis justo eu leo congue malesuada. Duis eget velit tellus. Aliquam et erat egestas massa sagittis accumsan.',
    lessonFileId: '1rKesjDfhGX0miYeJ6iwU9wpGpKDZ2IZP',
    lessonTitle: 'Cyber Security and Encryption',
    mnStandards: { art: ['1.1.1.1', '2.2.2.2', '3.3.3.3', '4.4.4.4', '5.5.5.5'] },
    permissionGranted: true,
    platforms: ['Scratch'],
    schoolDistrict: '1',
    schoolName: 'Sunnyvale Elementary',
    schoolState: 'MN',
    schoolZipCode: 12345,
    subjectAreas: [Subject.COMPUTER_SCIENCE, Subject.SCIENCE],
    submissionApproved: undefined,
    technologies: ['Arduino', 'Other'],
    timestamp: '12345',
    twitterId: 'abc',
  },
];

export default MockLessons;
